// Canonical account-type ordering + display labels for the active-portfolio
// hero/breakdown (PHX-151). Matches useInvestmentStore's classification in
// _classifyAccountType().
export const ACCOUNT_TYPE_ORDER = ["Personal", "Joint", "IRA", "Entity"];

export const ACCOUNT_TYPE_LABELS = {
  Personal: "Personal investments",
  Joint: "Joint investments",
  IRA: "IRA investments",
  Entity: "Entity investments",
};
